/* eslint-disable  */
/* eslint-disable no-redeclare */
/* eslint-disable eqeqeq */
/* eslint-disable no-unused-vars */
// React Components
/* eslint-disable */
import React, { useEffect, useState, Suspense, lazy } from "react";
/* eslint-disable */
import "../layout-one/sass/app.scss";
/* eslint-disable */
import ReactGA from "react-ga";
import { configure } from "mobx";
import DineInMain from "./DineInMain.jsx";
import DeliveryMain from "./DeliveryMain";
import BartonLoadingPage from "../sharedComponent/bartonLoadingPage/BartonLoadingPage";
import { use } from "react";
import { useSelector } from "react-redux";

// const BartonLoadingPage = lazy(() => import(
//   '../sharedComponent/BartonLoadingPage/BartonLoadingPage'))

configure({
  isolateGlobalState: true,
});
// const TRACKING_ID = "UA-243425614-1"; // OUR_TRACKING_ID
// ReactGA.initialize(TRACKING_ID);

function Main({ t, i18n }) {
  const appState = useSelector((appState) => appState);
  const [appMode, setAppMode] = useState(0);
  const [isLoading, setIsLoading] = useState(true);
  useEffect(() => {
    let initial_mount = true;
    if (initial_mount) {
      let delivery = false;
  
      if (delivery) {
        setAppMode(2);
        setIsLoading(false);
      } else {
        setAppMode(1);
        setIsLoading(false);
      }
  
      let trakingDomain = !['app.enabill.com','shop.enabill.com','delviery.enabill.com','order.enabill.com'].includes(window.location.host);
      let gmt = process.env.REACT_APP_GTM_ID ?? null;
      let pixelID = process.env.REACT_APP_PIXEL_ID ?? null;
      let tikTokPixelID = process.env.REACT_APP_TIKTOK_PIXEL_ID ?? null;
      let conversationApiToken = process.env.REACT_APP_CONVERSATION_API_TOKEN ?? null;
  
      // if (trakingDomain) {
        if(gmt){
        // Load Google Analytics
        const gtagScript = document.createElement('script');
        gtagScript.async = true;
        gtagScript.src = `https://www.googletagmanager.com/gtag/js?id=${gmt}`;
        document.head.appendChild(gtagScript);
  
        gtagScript.onload = () => {
          window.dataLayer = window.dataLayer || [];
          function gtag() {
            window.dataLayer.push(arguments);
          }
          gtag('js', new Date());
          gtag('config', gmt);
        };
      }
      if(pixelID){
        // Load Facebook Pixel
        const fbPixelScript = document.createElement('script');
        fbPixelScript.innerHTML = `
          !function(f,b,e,v,n,t,s)
          {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
          n.callMethod.apply(n,arguments):n.queue.push(arguments)};
          if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
          n.queue=[];t=b.createElement(e);t.async=!0;
          t.src=v;s=b.getElementsByTagName(e)[0];
          s.parentNode.insertBefore(t,s)}(window, document,'script',
          'https://connect.facebook.net/en_US/fbevents.js');
          fbq('init', '${pixelID}');
          fbq('track', 'PageView');
        `;
        fbPixelScript.setAttribute('type', 'text/javascript');
        document.head.appendChild(fbPixelScript);
  
        // Optional: add noscript fallback
        const noscript = document.createElement('noscript');
        noscript.innerHTML = `
          <img height="1" width="1" style="display:none"
          src="https://www.facebook.com/tr?id=${pixelID}&ev=PageView&noscript=1"/>
        `;
        document.body.appendChild(noscript);
      }
      if(tikTokPixelID){
        // Load TikTok Pixel
        !(function (w, d, t) {
          w.TiktokAnalyticsObject=t;
          var tt=w[t]=w[t]||[];
          tt.methods=["page","track"];
          tt.setAndDefer=function(t,e){t[e]=function(){t.push([e].concat(Array.prototype.slice.call(arguments,0)))}};
          for(var i=0;i<tt.methods.length;i++)tt.setAndDefer(tt,tt.methods[i]);
          tt.load=function(e){var i="https://analytics.tiktok.com/i18n/pixel/events.js";
            tt._i=tt._i||{},tt._i[e]=[];
            var o=document.createElement("script");o.async=!0;o.src=i+"?sdkid="+e;
            var a=document.getElementsByTagName("script")[0];a.parentNode.insertBefore(o,a)
          };
          tt.load(tikTokPixelID);
          tt.page();
          tt.track('PageView');
        })(window, document, 'ttq');
      }
      
      if(conversationApiToken){
        // Initialize Conversation API
        window.conversationApiConfig = {
          token: conversationApiToken,
          baseUrl: process.env.REACT_APP_CONVERSATION_API_URL || 'https://api.conversation.com',
          initialized: false
        };
        
        // Create conversation API utility functions
        window.conversationApi = {
          // Initialize the conversation API
          init: function() {
            if (window.conversationApiConfig.initialized) return;
            
            // Set up global headers for all conversation API requests
            window.conversationApiHeaders = {
              'Authorization': `Bearer ${conversationApiToken}`,
              'Content-Type': 'application/json'
            };
            
            window.conversationApiConfig.initialized = true;
            console.log('Conversation API initialized with token');
          },
          
          // Track conversation events
          track: function(eventName, eventData = {}) {
            if (!window.conversationApiConfig.initialized) {
              this.init();
            }
            
            const payload = {
              event: eventName,
              timestamp: new Date().toISOString(),
              data: eventData,
              url: window.location.href,
              userAgent: navigator.userAgent
            };
            
            // Send to conversation API
            fetch(`${window.conversationApiConfig.baseUrl}/track`, {
              method: 'POST',
              headers: window.conversationApiHeaders,
              body: JSON.stringify(payload)
            }).catch(error => {
              console.warn('Conversation API tracking failed:', error);
            });
          },
          
          // Send conversation message
          sendMessage: function(message, context = {}) {
            if (!window.conversationApiConfig.initialized) {
              this.init();
            }
            
            const payload = {
              message: message,
              context: context,
              timestamp: new Date().toISOString(),
              url: window.location.href
            };
            
            return fetch(`${window.conversationApiConfig.baseUrl}/conversation`, {
              method: 'POST',
              headers: window.conversationApiHeaders,
              body: JSON.stringify(payload)
            }).then(response => response.json())
              .catch(error => {
                console.warn('Conversation API message failed:', error);
                return { error: error.message };
              });
          }
        };
        
        // Initialize the conversation API
        window.conversationApi.init();
        
        // Track page view
        window.conversationApi.track('page_view', {
          page: window.location.pathname,
          title: document.title
        });
      }
    // }`
    }
    return () => {
      initial_mount = false;
    };
  }, []);
  
  return appMode == 1 ? <div> <DineInMain />  </div>: appMode == 2  ? <div> <DeliveryMain />  </div>:  <div> <BartonLoadingPage /> </div>;

}

export default Main;
